<template>
  <PrivacySection title="3. Dati che Possono Essere Eliminati">
    <PrivacySubsection title="3.1 Dati Memorizzati sul Dispositivo (App Mobile)">
      <ul>
        <li><strong>Codice Lotteria:</strong> memorizzato localmente per facilitare
            l'accesso al servizio governativo</li>
        <li><strong>Preferenze dell'app:</strong> impostazioni e configurazioni salvate
            sul dispositivo</li>
        <li><strong>Dati tecnici locali:</strong> cache e file temporanei dell'applicazione</li>
      </ul>
      <p>
        <strong>Nota:</strong> il Codice Fiscale inserito per accedere al servizio
        governativo <strong>non viene memorizzato</strong> sui nostri server né sul
        dispositivo in modo persistente oltre alla sessione di utilizzo.
      </p>
    </PrivacySubsection>

    <PrivacySubsection title="3.2 Dati Memorizzati sui Nostri Server">
      <ul>
        <li><strong>Dati del modulo di contatto:</strong> nome, email, oggetto e messaggio
            inviati tramite il form di contatto</li>
        <li><strong>Dati di navigazione del sito web:</strong> indirizzo IP, pagine visitate,
            data e ora di accesso (log tecnici)</li>
        <li><strong>Dati analitici aggregati:</strong> statistiche di utilizzo anonime
            raccolte tramite Firebase Analytics</li>
      </ul>
    </PrivacySubsection>
  </PrivacySection>
</template>

<script>
import PrivacySection from '@/components/privacy/PrivacySection.vue'
import PrivacySubsection from '@/components/privacy/PrivacySubsection.vue'

export default {
  name: 'DataTypesSection',
  components: {
    PrivacySection,
    PrivacySubsection
  }
}
</script>
